import { AttentionTarget } from '@/types/stats/AttentionTarget.ts';

/** Napis odsyłacza dobrany do celu — „Otwórz finanse” czyta się lepiej niż „Otwórz”. */
export const ATTENTION_TARGET_ACTION_LABELS: Record<AttentionTarget, string> = {
  [AttentionTarget.FINANCES]: 'Otwórz finanse',
  [AttentionTarget.BUDGET]: 'Otwórz budżet',
  [AttentionTarget.WAITLIST]: 'Otwórz listę rezerwową',
  [AttentionTarget.MESSAGES]: 'Otwórz wiadomości',
  [AttentionTarget.PARTICIPANTS]: 'Otwórz uczestników',
  [AttentionTarget.OPTIONS]: 'Otwórz opcje',
  [AttentionTarget.TOUR_SETTINGS]: 'Otwórz ustawienia wyjazdu',
  [AttentionTarget.SETTINGS]: 'Otwórz ustawienia firmy',
  [AttentionTarget.ACCESS]: 'Otwórz dostęp',
  [AttentionTarget.CONSENTS]: 'Otwórz umowy',
  [AttentionTarget.CHANGES]: 'Otwórz zmiany',
  [AttentionTarget.DISCOUNTS]: 'Otwórz kody promocyjne',
  [AttentionTarget.TFG]: 'Otwórz TFG',
  [AttentionTarget.TRANSPORT]: 'Otwórz transport',
  [AttentionTarget.CLIENTS]: 'Otwórz zapisujących',
  [AttentionTarget.TOUR]: 'Otwórz wyjazd',
};

export const getAttentionTargetActionLabel = (
  target: AttentionTarget,
): string => ATTENTION_TARGET_ACTION_LABELS[target];
